import styled from "@emotion/styled";

import { StyledTextField } from "scmp-app/components/posties/student-form/styles";

export const UploadField = styled(StyledTextField)`
  & .MuiInputBase-root {
    padding-block: 0;
    padding-inline: 0;

    & .MuiInputBase-input {
      padding-block: 18px 20px;
      padding-inline: 20px;
    }
  }
`;
